<template>
	<div class="cw-latest-news">
		最新资讯
  	</div>
</template>

<script>

export default {

	data() {
		return {

		}
	},

	computed: {
      
    },

	created() {

	},

	mounted() {

	},

	methods: {

	}
}
</script>

<style lang="scss" scoped>
.cw-latest-news {
    padding-top: 104px;
    font-size: 12px;
}
</style>

